import React, { useState } from "react";
import { Range, getTrackBackground } from "react-range";

const RangeSlider = ({ onChange, onFinalChange, step, min, max, value }) => {
  const [values, setValues] = useState([value]);

  const handleSliderChange = (values) => {
    setValues(values);
    onChange(values[0]); // Call the onChange prop with the selected value
  };
  const handleFinalChange = (values) => {
    setValues(values);
    onChange(values[0]); // Call the onChange prop with the selected value
    onFinalChange(values[0]);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        margin: "2em",
        // background: "rgb(20 184 166 / 1)",
      }}
    >
      <Range
        values={values}
        step={step}
        min={min}
        max={max}
        onChange={handleSliderChange}
        onFinalChange={handleFinalChange}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
              height: "30px",
              display: "flex",
              width: "100%",
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: "10px",
                width: "100%",
                borderRadius: "10px",
                background: getTrackBackground({
                  values: values,
                  colors: ["#D1D9D8", "#D1D9D8"],
                  min: min,
                  max: max,
                }),
                alignSelf: "center",
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props, isDragged }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: "30px",
              width: "30px",
              borderRadius: "50%",
              backgroundColor: "#898989",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                height: "0px",
                width: "0px",
                backgroundColor: isDragged ? "#898989" : "#898989",
              }}
            />
          </div>
        )}
      />
    </div>
  );
};

export default RangeSlider;
